var NAMESPACE = 'td';

var Switch = { render: function render() {
    var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;return _c('div', { staticClass: "td-switch", class: { 'is-disabled': _vm.disabled, 'is-checeked': _vm.value } }, [_c('div', { staticClass: "td-switch__inner", on: { "click": function click($event) {
          $event.preventDefault();return _vm.switchValue($event);
        } } }), _vm._v(" "), _c('span', { staticClass: "td-switch__text" }, [_vm.value ? _vm._t("open") : _vm._e(), _vm._v(" "), !_vm.value ? _vm._t("close") : _vm._e()], 2)]);
  }, staticRenderFns: [],
  name: NAMESPACE + '-switch',
  props: {
    value: {
      type: [String, Number, Boolean],
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    switchValue: function switchValue() {
      !this.disabled && this.handleChange();
    },
    handleChange: function handleChange() {
      this.$emit('input', !this.value);
      this.$emit('change', !this.value);
    }
  }
};

Switch.install = function (Vue) {
  Vue.component(Switch.name, Switch);
};

export default Switch;
